import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import CloseIcon from '@/assets/icons/close-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';
import { IMAGE_DIMENSIONS } from '@/constants/ActivitiesConfig.js';

const CommentImageThumbnailEditor = ({ imageUrl, onRemove, onClick }) => {
    return (
        <Box
            onClick={onClick}
            sx={{
                position: 'relative',
                width: IMAGE_DIMENSIONS.THUMBNAIL_EDITOR_SIZE,
                height: IMAGE_DIMENSIONS.THUMBNAIL_EDITOR_SIZE,
                minWidth: IMAGE_DIMENSIONS.THUMBNAIL_EDITOR_SIZE,
                borderRadius: '8px',
                overflow: 'visible',
                cursor: onClick ? 'pointer' : 'default',
                '&:hover': {
                    outline: `2px solid ${Palette.gray.gray300}`,
                    outlineOffset: '-2px',
                    '& .image-thumbnail-remove-button': {
                        visibility: 'visible',
                    },
                },
            }}
        >
            <Box
                component='img'
                src={imageUrl}
                alt=''
                sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                    borderRadius: '8px',
                    pointerEvents: 'none',
                }}
            />
            {onRemove && (
                <Box
                    component='button'
                    className='image-thumbnail-remove-button'
                    type='button'
                    onClick={e => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    sx={{
                        position: 'absolute',
                        top: '-10px',
                        right: '-10px',
                        width: 20,
                        height: 20,
                        borderRadius: '6px',
                        border: 'none',
                        padding: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: Palette.gray.gray900,
                        color: Palette.white,
                        fontSize: '12px',
                        lineHeight: 1,
                        cursor: 'pointer',
                        visibility: 'hidden',
                        '& svg path': {
                            stroke: Palette.white,
                        },
                    }}
                >
                    <CloseIcon />
                </Box>
            )}
        </Box>
    );
};

CommentImageThumbnailEditor.propTypes = {
    imageUrl: PropTypes.string.isRequired,
    onRemove: PropTypes.func,
    onClick: PropTypes.func,
};

export default CommentImageThumbnailEditor;
